$(document).ready(function () {

    if (!$('#esim-page').length) {
        return;
    }

    $('#slick2').slick({
        dots: false,
        prevArrow: false,
        nextArrow: false,
        centerMode: false,
        centerPadding: '60px',
        infinite: false,
        slidesToShow: 3,
        responsive: [{
            breakpoint: 850,
            settings: {
                arrows: false,
                variableWidth: true,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3
            }
        },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            },

        ]
    });
})
